import { useCallback } from 'react';
import { ipApi } from '../services/api';
import { useLiveData } from './useLiveData';

/** Map API record to UI shape (id alias). */
export function mapHmsRecord(r) {
  if (!r) return r;
  return { ...r, id: r.recordId || r.id };
}

/** Live HMS module records by type — create + patch helpers. */
export function useHmsRecords(recordType, limit = 120) {
  const { data, loading, error, reload } = useLiveData(
    () => ipApi.getHmsRecords(recordType, limit),
    [recordType, limit],
  );
  const records = (data?.records || []).map(mapHmsRecord);

  const create = useCallback(async (body) => {
    const res = await ipApi.createHmsRecord({ recordType, ...body });
    await reload();
    return mapHmsRecord(res?.record);
  }, [recordType, reload]);

  const patch = useCallback(async (recordId, body) => {
    await ipApi.patchHmsRecord(recordId, body);
    await reload();
  }, [reload]);

  return { records, loading, error, reload, create, patch };
}

export function useHmsConfig(configType) {
  const { data, loading, error, reload } = useLiveData(
    () => ipApi.getHmsConfig(configType),
    [configType],
  );

  const save = useCallback(async (payload) => {
    await ipApi.saveHmsConfig({ configType, ...payload });
    await reload();
  }, [configType, reload]);

  return { config: data?.config || {}, loading, error, reload, save };
}
